// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginTemplate_root__33qQp"};